import { useEffect } from 'react';

const useDeleteKeyHandler = (canvas, deleteSelectedObject) => {
  useEffect(() => {
    function handleKeyDown(e) {
      if (!canvas) {
        return;
      }
      if (e.key === 'Delete' || e.key === 'Backspace') {
        deleteSelectedObject(canvas);
      }
    }

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [canvas, deleteSelectedObject]);
};

export default useDeleteKeyHandler;